import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import app from '../../firebase/config';

const getRegionalFunctions = () => getFunctions(app, 'europe-west10');

const callProfileFunction = async <TResult>(
  name: string,
  payload?: Record<string, unknown>
): Promise<TResult> => {
  const fn = httpsCallable(getRegionalFunctions(), name);
  const result = await fn(payload || {});
  return result.data as TResult;
};

export const ensureBackendUserProfile = async (
  payload: Record<string, unknown> = {}
): Promise<void> => {
  await callProfileFunction<{ ok: true }>('ensureUserProfile', payload);
};

export const syncBackendLibraryCounters = async (): Promise<{ libraryCount: number }> => {
  return callProfileFunction<{ libraryCount: number }>('syncLibraryCounters');
};

export const syncBackendShareCounters = async (expectedUid?: string): Promise<{
  activeSharesCount: number;
  totalSharesCreated: number;
  totalShareViews: number;
}> => {
  if (expectedUid && getAuth().currentUser?.uid !== expectedUid) {
    throw new Error('Not authorized to sync these share counters');
  }

  return callProfileFunction<{
    activeSharesCount: number;
    totalSharesCreated: number;
    totalShareViews: number;
  }>('syncShareCounters');
};
